<template>
<div class="content">
  <!-- 面包屑 -->
  <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">设备管理</li>
      </ul>
    </div> -->
  <el-tabs class="tabLv3" type="border-card" v-model="tabName">
    <i class="lt"></i>
    <i class="rt"></i>
    <el-tab-pane name="jsgl">
      <span slot="label">
        <i class="iconfont iconcheck"></i>
        <i class="border"></i> 网关
      </span>
      <div class="searchForm1">
        <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
          <template slot="last">
            <el-form-item label="设备名称">
              <el-input placeholder="请输入设备名称" v-model="seefrom.device_name"></el-input>
            </el-form-item>
            <el-form-item label="网关名称">
              <el-input placeholder="请输入网关名称" v-model="seefrom.gateway_name"></el-input>
            </el-form-item>
          </template>
        </searchForm>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
      </div>
      <div class="tableWrapper" v-loading="!showTable">
        <!-- 后端分页 -->
        <easyTable apiUrl="operation/device/findDevices" :parent="self" :config="config" :other="other" ref="gataway">
          <template slot="last">
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <el-link icon="iconfont iconedit" type="text" size="small" @click="edit(scope.$index, scope.row)">编辑</el-link>
                <el-link v-if="scope.row.deviceRelateId" icon="iconfont icondelete" type="text" size="small" @click="deleteDevice(scope.$index, scope.row)">删除</el-link>
                <!-- <el-link icon="iconfont iconadd" type="text" size="small">添加</el-link> -->
              </template>
            </el-table-column>
          </template>
        </easyTable>
      </div>
      <!-- <el-dialog class="editDialog" title="修改用户信息" :visible.sync="editDialogVisible">
          <searchForm :items="items"></searchForm>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="editDialogVisible = false">取消</el-button>
            <el-button class="confirmButton" type="primary" @click="editDialogVisible = false">确定</el-button>
          </div>
        </el-dialog>-->
      <el-dialog class="editDialog" title="设备关联编辑" :visible.sync="editDialogForm" v-if="editDialogForm" @close="reseteditDialog" :close-on-click-modal="false">
        <row :_gutter="20">
          <cell>
            <el-form :model="addEquipment" :rules="rules" ref="addEquipment">
              <el-form-item label="设备名称" prop="device_name">
                <el-input placeholder="请输入设备名称" v-model="addEquipment.device_name" readonly></el-input>
              </el-form-item>
              <el-form-item label="网关名称" prop="gateway_name">
                <!-- <el-input v-model="addEquipment.gateway"></el-input> -->
                <el-select filterable :popper-append-to-body="false" v-model="addEquipment.gateway_name" placeholder="请选择网关名称" @change="initGatawayId">
                  <el-option v-for="item in Gateway" :key="item.id" :value="item.id" :label="item.deviceName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="通道" prop="aisle">
                <el-input placeholder="请输入通道" v-model="addEquipment.aisle"></el-input>
              </el-form-item>
            </el-form>
          </cell>
          <cell v-if="modbusFlag">
            <getawayPlus ref="getawayPlus" :deviceType="deviceType" v-model="addEquipment.modbuses"></getawayPlus>
          </cell>

        </row>
        <div slot="footer" class="dialog-footer">
          <el-button class="cancelButton" @click="editDialogForm = false">取消</el-button>
          <el-button class="confirmButton" @click="Confirm">确定</el-button>
        </div>
      </el-dialog>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import {
  dt,
  obj2urlsp
} from "utils";
export default {
  data() {
    return {
      id: "",
      tabName: "jsgl",
      loading: true,
      form_jsgl: {},
      editDialogForm: false,
      editDialogVisible: false,
      showTable: true,
      other: {
        device_kind: 2
      },
      items: [],
      Gateway: [],
      seefrom: {
        device_name: "",
        gateway_name: ""
      },
      addEquipment: {
        device_name: "",
        gateway_name: "",
        gateway_id: "",
        aisle: "",
        modbuses:[]
      },
      rules: {
        gateway_name: [{
          required: true,
          message: "请输入网关名称",
          trigger: "blur"
        }],
        aisle: [{
          required: true,
          message: "请输入通道名称",
          trigger: "blur"
        }]
      },
      modbusFlag: false,
      deviceType:''
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [{
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "gateName",
          label: "网关名称"
        },
        {
          prop: "aisle",
          label: "通道"
        }
        // {
        //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
        //   label: "随便"
        // }
      ];
    },
    dt() {
      return dt.map(({
        label
      }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    getawayPlus: () => import("./getawayPlus")
  },
  methods: {
    reseteditDialog() {
      this.addEquipment = {
        device_name: "",
        gateway_name: "",
        gateway_id: "",
        aisle: ""
      }
      this.modbusFlag = false;
    },
    initGatawayId(val) {
      if (val) {
        this.addEquipment.gateway_id = val;
        let item = this.Gateway.find(o => o.id == val);
        this.modbusFlag = item.modbusFlag;
      }
      //   let factoryId = val || this.firmlevel.factoryId;
      //   let temp = this.factoryList.find(it => it.id === factoryId);
      //   if (temp) {
      //     this.firmlevel.factory = temp.name;
      //   }
    },
    //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.other.device_kind = 2;
      this.$refs.gataway.pageToOne();
      this.$nextTick(this.$refs.gataway.getData);
    },
    //重置
    reset() {
      this.seefrom = {};
    },
    //编辑
    edit(index, row) {
      this.editDialogForm = true;
      //console.log(index, row)
      // this.$refs.addEquipment.resetFields();
      this.addEquipment.device_name = row.deviceName;
      this.addEquipment.gateway_name = row.gateName;
      this.addEquipment.gateway_id = row.gateway_id;
      this.initGatawayId(row.gateway_id);
      this.addEquipment.aisle = row.aisle;
      this.addEquipment.modbuses = row.modbuses||[]
      this.id = row.id;
      this.deviceType=row.deviceType;
    },
    // 删除设备关联
    deleteDevice(index, row) {
      this.$confirm('确定要删除该设备关联吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosget("operation/device/removeDeviceRelate", {
          params: {
            id: row.deviceRelateId
          }
        }).then(res => {
          if (res.data.status === "10000") {
            this.$message.success("删除成功！");
            this.subSeefrom(); // 重新加载数据
          } else {
            this.$message.error(res.data.message || "删除失败");
          }
        }).catch(err => {
          this.$message.error("删除失败");
        });
      }).catch(() => {
        // 用户取消删除
      });
    },
    //确认
    Confirm() {
      this.$refs.addEquipment.validate(valid => {
        if (valid) {
          //console.log(this.addEquipment.gateway_id, this.addEquipment.gateway_name)
          this.$axiospost("operation/device/saveDeviceRelate", {
            device_id: this.id,
            gateway_id: this.addEquipment.gateway_id ? this.addEquipment.gateway_id : this.addEquipment.gateway_name,
            aisle: this.addEquipment.aisle,
            modbuses: this.addEquipment.modbuses
          }).then(res => {
            if (res.data.status === "10000") {
              this.editDialogForm = false;
              this.subSeefrom();
              this.$message.success("保存成功！");
            } else if (res.data.status === 505) {
              this.$message.warning("该网关通道已被关联！");
            }
          });
        } else {
          this.$message.warning("请输入必填项");
        }
      });
    }
  },
  created() {
    this.$axiosget("operation/device/findTypeDevices", {
      params: {
        device_kind: 1
      }
    }).then(res => {
      //console.log(123);
      this.Gateway = res.data.data;
      //console.log(this.Gateway)
    });
  }
};
</script>

<style lang="less" scoped>
.w_normalNav {
  padding-top: 10px;
  width: 10%;
}
.searchForm1{
  display: flex;
  justify-content: space-between;
  align-items: center;
  /deep/.el-form{
    width: 90%;
  }
}
.editDialog {
  /deep/ .el-dialog__body {
    padding-top: 0
  }

  /deep/ .el-dialog {
    width: 800px;

    .el-form-item__content,
    .el-input__inner,
    .el-select {
      width: 100%;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/gataway.vue